export const isObjectNullOrEmpty = (obj) => {
  var isNullOrEmpty = false;
  if (obj !== null && obj !== "" && obj !== undefined) {
    isNullOrEmpty = false;
  } else {
    isNullOrEmpty = true;
  }

  return isNullOrEmpty;
};
export const campoNumero = (valor) => {
  if (valor)
    return valor
      .toString()
      ?.split("")
      .filter((n) => Number(n) || n === "0")
      .join("");
  return valor;
};

export const addMascaraReal = (valorFormatar) => {
return new Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(valorFormatar);
};

export const formatarDouble = (valorFormatar)=>{
  return new Intl.NumberFormat('pt-br').format(valorFormatar);
}

